import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import ProtectedRouteV2 from './ProtectedRouteV2';
import FeatureProtectedRoute from './FeatureProtectedRoute';
import PermissionProtectedRoute from './PermissionProtectedRoute';
import { SYSTEM_FEATURE } from '../types/system/features';
import CashOpening from '../pages/Cash/CashOpening';
import CashClosingX from '../pages/Cash/CashClosingX';
import CashClosingZ from '../pages/Cash/CashClosingZ';
import CashStatusPage from '../pages/Cash/CashStatusPage';
import CashIncomePage from '../pages/Cash/CashIncomePage';
import CashWithdrawalPage from '../pages/Cash/CashWithdrawalPage';
import CashRegistersPage from '../pages/Cash/CashRegistersPage';
import CashAdjustmentPage from '../pages/Cash/CashAdjustmentPage';
import CashCountPage from '../pages/Cash/CashCountPage';
import CashPendingSalesPage from '../pages/Cash/CashPendingSalesPage';
import CashClosuresHistoryPage from '../pages/Cash/CashClosuresHistoryPage';
import CashAdminMonitorPage from '../pages/Cash/CashAdminMonitorPage';

/**
 * 💰 cashRoutes
 *
 * Rutas protegidas del módulo "Caja".
 * - Totalmente alineadas con las rutas definidas en el backend (CashMenuBuilder).
 * - Incluye apertura de caja, cortes X/Z y arqueo.
 */
const cashRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route element={<FeatureProtectedRoute feature={SYSTEM_FEATURE.CASH_REGISTER} />}>
    {/* 🔹 Terminales POS */}
    <Route
      path="/cash/registers"
      element={
        <>
          <PageTitle title="Terminales POS | Codenova POS" />
          <CashRegistersPage />
        </>
      }
    />

    {/* 🔹 Apertura de Caja */}
    <Route
      path="/cash/opening"
      element={
        <>
          <PageTitle title="Apertura de Caja | Codenova POS" />
          <CashOpening />
        </>
      }
    />

    <Route
      path="/cash/status"
      element={
        <>
          <PageTitle title="Estado de Caja | Codenova POS" />
          <CashStatusPage />
        </>
      }
    />

    {/* 🔹 Ventas Pendientes */}
    <Route
      path="/cash/pending-sales"
      element={
        <>
          <PageTitle title="Ventas Pendientes | Codenova POS" />
          <CashPendingSalesPage />
        </>
      }
    />

    <Route
      path="/cash/income"
      element={
        <>
          <PageTitle title="Ingreso de Efectivo | Codenova POS" />
          <CashIncomePage />
        </>
      }
    />

    <Route
      path="/cash/withdrawal"
      element={
        <>
          <PageTitle title="Retiro de Efectivo | Codenova POS" />
          <CashWithdrawalPage />
        </>
      }
    />

    <Route
      path="/cash/adjustment"
      element={
        <>
          <PageTitle title="Ajuste de Caja | Codenova POS" />
          <CashAdjustmentPage />
        </>
      }
    />

    {/* 🔹 Corte X */}
    <Route
      path="/cash/summary-x"
      element={
        <>
          <PageTitle title="Corte X | Codenova POS" />
          <CashClosingX />
        </>
      }
    />

    {/* 🔹 Corte Z */}
    <Route
      path="/cash/summary-z"
      element={
        <>
          <PageTitle title="Corte Z | Codenova POS" />
          <CashClosingZ />
        </>
      }
    />

    {/* 🔹 Arqueo de Caja */}
    <Route
      path="/cash/audit"
      element={
        <>
          <PageTitle title="Arqueo de Caja | Codenova POS" />
          <CashCountPage />
        </>
      }
    />

    {/* 🔹 Historial de Cierres (solo SUPPORT) */}
    <Route element={<PermissionProtectedRoute perm="CASH_CLOSURES_VIEW" />}>
      <Route
        path="/cash/closures-history"
        element={
          <>
            <PageTitle title="Historial de Cierres | Codenova POS" />
            <CashClosuresHistoryPage />
          </>
        }
      />
      <Route
        path="/cash/closures-history/page/:page"
        element={
          <>
            <PageTitle title="Historial de Cierres | Codenova POS" />
            <CashClosuresHistoryPage />
          </>
        }
      />
    </Route>

    {/* 🔹 Monitoreo de Cajas (solo ADMIN/SUPPORT) */}
    <Route element={<PermissionProtectedRoute perm="CASH_MONITOR_VIEW" />}>
      <Route
        path="/cash/monitor"
        element={
          <>
            <PageTitle title="Monitoreo de Cajas | Codenova POS" />
            <CashAdminMonitorPage />
          </>
        }
      />
    </Route>
    </Route>
  </Route>
);

export default cashRoutes;
